import { Box, Modal, Tabs } from "fds";
import "./index.scss";
import { t } from "i18next";
import { useState } from "react";
import TermsPage from "./TermsPage";
import PrivacyPage from "./PrivacyPage";

type ModalProps = {
  open: boolean;
  onClose: () => void;
};
const PolicyModal: React.FC<ModalProps> = ({ open, onClose }) => {
  const [tab, changeTab] = useState(0); // 0 : 상세정보 , 1: 파일 이력

  return (
    <Modal
      open={open}
      onClose={onClose}
      title=""
      width={1000}
      bodyHeight={700}
      isFooter={false}
      body={
        <Box direction="column">
          <Tabs
            tabs={[t("plan.useTerms"), t("plan.personalInfo")].map((item) => {
              return { text: item, color: "theme", isNew: false };
            })}
            size="md"
            type="full"
            selected={tab}
            selectTab={(tab) => changeTab(tab)}
          />
          <Box>
            {tab === 0 ? (
              <TermsPage height={640} />
            ) : (
              <PrivacyPage height={640} />
            )}
          </Box>
        </Box>
      }
    />
  );
};

export default PolicyModal;
